__webpack_require__.p = "https://devcdn.infra.veevaappstats.com/rev-stats/assets/";